import { PropsWithChildren, useEffect, useRef } from 'react'
import { observer } from 'mobx-react-lite'
import { useLayout } from 'stores/LayoutStore'
import { Portal } from 'components/Portal/Portal'

export const RightColumn = observer(({ children }: PropsWithChildren) => {
  const layout = useLayout()
  const ref = useRef(null)

  useEffect(
    function removeExistingChildren() {
      if (ref.current && layout.rightColumn) {
        while (layout.rightColumn.firstChild && !layout.rightColumn.firstChild.isEqualNode(ref.current)) {
          layout.rightColumn.removeChild(layout.rightColumn.firstChild)
        }
      }
    },
    [layout.rightColumn],
  )

  if (!layout.rightColumn) return null

  return (
    <Portal container={layout.rightColumn}>
      <span ref={ref}>{children}</span>
    </Portal>
  )
})
